/* eslint-disable max-len */

export enum PermissionEnum {
  // Top-level keys
  ActivityLog = 'ActivityLog',
  AIDocumentManager = 'AIDocumentManager',
  Configurator = 'configurator',
  Dashboard = 'dashboard',
  External = 'external',
  NZM = 'NZM',
  OrgManager = 'orgManager',
  ESG = 'ESG',
  HOME = 'HOME',
  ReportStudio = 'ReportStudio',
  PlatformEducation = 'LearningHub',

  // Configurator hierarchy
  ConfiguratorDataManagement = 'configurator:DataManagement',
  ConfiguratorEmissionFactorDatabase = 'configurator:DataManagement:emissionFactorDatabase',

  ConfiguratorOrganisationFacilities = 'configurator:OrganisationFacilities',
  ConfiguratorFacilitiesBusiness = 'configurator:OrganisationFacilities:business',
  ConfiguratorFacilitiesEmployee = 'configurator:OrganisationFacilities:employee',
  ConfiguratorFacilitiesFacility = 'configurator:OrganisationFacilities:facility',
  ConfiguratorFacilitiesGeneral = 'configurator:OrganisationFacilities:general',
  ConfiguratorFacilitiesHoldings = 'configurator:OrganisationFacilities:holdings',

  ConfiguratorOrganisationHierarchy = 'configurator:OrganisationHierarchy',
  ConfiguratorProcessFlow = 'configurator:ProcessFlow',
  ConfiguratorUserManagement = 'configurator:UserManagement',

  ConfiguratorValueChainManagement = 'configurator:valueChainManagement',
  ConfiguratorSupplierInfo = 'configurator:valueChainManagement:supplierInfo',
  // ConfiguratorDownstream = 'configurator:valueChainManagement:supplierInfo:downstream',
  ConfiguratorDownstream = 'configurator:valueChainManagement:supplierInfo',
  // ConfiguratorUpstream = 'configurator:valueChainManagement:supplierInfo:upstream',
  ConfiguratorUpstream = 'configurator:valueChainManagement:supplierInfo',
  ConfiguratorProduct = 'configurator:valueChainManagement:product',
  ConfiguratorFranchise = 'configurator:valueChainManagement:franchise',
  ConfiguratorAsset = 'configurator:valueChainManagement:assets',

  // Dashboard hierarchy
  DashboardMetrics = 'dashboard:metrics',
  DashboardStakeholderTracking = 'dashboard:StakeholderTracking',

  // External hierarchy
  ExternalAnalytics = 'external:Analytics',
  ExternalInput = 'external:input',
  ExternalUserManager = 'external:UserManager',
  ExternalEnergyConsumptions = 'external:input:EnergyConsumptions',
  ExternalUpstreamDownstreamData = 'external:input:UpStreamDownStreamData',
  ExternalElectricity = 'external:input:EnergyConsumptions:electricity',
  ExternalFuelConsumption = 'external:input:EnergyConsumptions:fuelConsumption',
  ExternalProduct = 'external:input:UpStreamDownStreamData:Product',
  ExternalRawMaterial = 'external:input:UpStreamDownStreamData:RawMaterial',
  ExternalWasteGeneration = 'external:input:WasteGeneration',

  // NZM hierarchy
  NZMAsset = 'NZM:Asset',
  NZMGeneralized = 'NZM:Generalized',
  NZMProducts = 'NZM:Products',
  NZMSupplyChain = 'NZM:supplyChain',
  NZMTravel = 'NZM:Travel',
  NZMUtilities = 'NZM:Utilities',
  // NZMUtilitiesElectricity = 'NZM:Utilities:Electricity',
  // NZMUtilitiesFuel = 'NZM:Utilities:Fuel',
  // NZMUtilitiesWaste = 'NZM:Utilities:Waste',
  // NZMUtilitiesWater = 'NZM:Utilities:Water',
  NZMUtilitiesElectricity = 'NZM:Utilities',
  NZMUtilitiesFuel = 'NZM:Utilities',
  NZMUtilitiesWaste = 'NZM:Utilities',
  NZMUtilitiesWater = 'NZM:Utilities',

  DataLineage = 'dataLineage',

  // OrgManager hierarchy
  OrgManagerAssetManager = 'orgManager:AssetManager',
  // OrgManagerDownstreamProperty = 'orgManager:AssetManager:DownstreamLeasedAsset:Property',
  // OrgManagerDownstreamVehicle = 'orgManager:AssetManager:DownstreamLeasedAsset:Vehicle',
  OrgManagerAssetsDownstreamLeased = 'orgManager:AssetManager:DownstreamLeasedAsset',
  OrgManagerDownstreamProperty = 'orgManager:AssetManager:DownstreamLeasedAsset',
  OrgManagerDownstreamVehicle = 'orgManager:AssetManager:DownstreamLeasedAsset',
  OrgManagerFranchise = 'orgManager:AssetManager:Franchise',
  OrgManagerAssetsUpstreamLeased = 'orgManager:AssetManager:UpstreamLeasedAsset',
  // OrgManagerUpstreamProperty = 'orgManager:AssetManager:UpstreamLeasedAsset:Property',
  // OrgManagerUpstreamVehicle = 'orgManager:AssetManager:UpstreamLeasedAsset:Vehicle',
  OrgManagerUpstreamProperty = 'orgManager:AssetManager:UpstreamLeasedAsset',
  OrgManagerUpstreamVehicle = 'orgManager:AssetManager:UpstreamLeasedAsset',

  OrgManagerInfrastructureProfile = 'orgManager:InfrastructureProfile',
  OrgManagerCapitalGoods = 'orgManager:InfrastructureProfile:CapitalGoods',
  // OrgManagerCapitalGoodsAverageMethod = 'orgManager:InfrastructureProfile:CapitalGoods:AverageMethod',
  // OrgManagerCapitalGoodsSupplierSpecificMethod = 'orgManager:InfrastructureProfile:CapitalGoods:SupplierSpecificMethod',
  OrgManagerCapitalGoodsAverageMethod = 'orgManager:InfrastructureProfile:CapitalGoods',
  OrgManagerCapitalGoodsSupplierSpecificMethod = 'orgManager:InfrastructureProfile:CapitalGoods',

  OrgManagerOtherActivities = 'orgManager:InfrastructureProfile:OtherActivities',
  OrgManagerSupplyChain = 'orgManager:InfrastructureProfile:SupplyChain',
  // OrgManagerSupplyChainDownstream = 'orgManager:InfrastructureProfile:SupplyChain:Downstream',
  // OrgManagerSupplyChainUpstream = 'orgManager:InfrastructureProfile:SupplyChain:Upstream',
  OrgManagerSupplyChainDownstream = 'orgManager:InfrastructureProfile:SupplyChain',
  OrgManagerSupplyChainUpstream = 'orgManager:InfrastructureProfile:SupplyChain',
  OrgManagerProduct = 'orgManager:Product',
  OrgManagerProductRawMaterial = 'orgManager:Product:RawMaterial',
  // OrgManagerProductRawMaterialAverage = 'orgManager:Product:RawMaterial:Average',
  // OrgManagerProductRawMaterialSupplierSpecific = 'orgManager:Product:RawMaterial:SupplierSpecific',
  OrgManagerProductRawMaterialAverage = 'orgManager:Product:RawMaterial',
  OrgManagerProductRawMaterialSupplierSpecific = 'orgManager:Product:RawMaterial',
  OrgManagerProductProcessingOfSoldProduct = 'orgManager:Product:ProcessingOfSoldProductsB2B',
  // OrgManagerProductProcessingOfSoldProductAverage = 'orgManager:Product:ProcessingOfSoldProductsB2B:Average',
  // OrgManagerProductProcessingOfSoldProductSupplierSpecific = `orgManager:Product:
  // ProcessingOfSoldProductsB2B:SupplierSpecific`,
  OrgManagerProductProcessingOfSoldProductAverage = 'orgManager:Product:ProcessingOfSoldProductsB2B',
  OrgManagerProductProcessingOfSoldProductSupplierSpecific = 'orgManager:Product:ProcessingOfSoldProductsB2B',
  OrgManagerProductUseOfSoldProducts = 'orgManager:Product:UseOfSoldProductsB2C',
  OrgManagerProductUseOfSoldProductsDCE = 'orgManager:Product:UseOfSoldProductsB2C:DirectlyConsumeEnergy',
  OrgManagerProductUseOfSoldProductsFuelsAndFeedstocks = 'orgManager:Product:UseOfSoldProductsB2C:FuelsAndFeedstocks',
  OrgManagerProductUseOfSoldProductsGGC = 'orgManager:Product:UseOfSoldProductsB2C:GreenhouseGasesContained',
  OrgManagerEOLT = 'orgManager:Product:EndOfLifeTreatment',

  OrgManagerTravel = 'orgManager:InfrastructureProfile:Travel',
  // OrgManagerBusinessTravel = 'orgManager:InfrastructureProfile:Travel:BusinessTravel',
  // OrgManagerEmployeeCommute = 'orgManager:InfrastructureProfile:Travel:EmployeeCommute',
  OrgManagerBusinessTravel = 'orgManager:InfrastructureProfile:Travel',
  OrgManagerEmployeeCommute = 'orgManager:InfrastructureProfile:Travel',

  OrgManagerUtilities = 'orgManager:InfrastructureProfile:utilities',
  OrgInfraUtilFuel = 'orgManager:InfrastructureProfile:utilities:fuelConsumption',
  // OrgManagerFuelByMachine = 'orgManager:InfrastructureProfile:utilities:fuelConsumption:ByMachine',
  OrgManagerFuelByMachine = 'orgManager:InfrastructureProfile:utilities:fuelConsumption',
  // OrgManagerFuelByVehicle = 'orgManager:InfrastructureProfile:utilities:fuelConsumption:ByVehicle',
  OrgManagerFuelByVehicle = 'orgManager:InfrastructureProfile:utilities:fuelConsumption',
  // OrgManagerFuelByRefrigerantSuppressant = 'orgManager:InfrastructureProfile:utilities:fuelConsumption:ByRefrigerantSuppressant',
  OrgManagerFuelByRefrigerantSuppressant = 'orgManager:InfrastructureProfile:utilities:fuelConsumption',
  OrgInfraUtilElectricity = 'orgManager:InfrastructureProfile:utilities:electricity',
  // OrgManagerNonRenewableElectricity = 'orgManager:InfrastructureProfile:utilities:electricity:NonRenewable',
  OrgManagerNonRenewableElectricity = 'orgManager:InfrastructureProfile:utilities:electricity',
  // OrgManagerRenewableElectricity = 'orgManager:InfrastructureProfile:utilities:electricity:Renewable',
  OrgManagerRenewableElectricity = 'orgManager:InfrastructureProfile:utilities:electricity',
  OrgManagerWaste = 'orgManager:InfrastructureProfile:utilities:Waste',
  OrgManagerWater = 'orgManager:InfrastructureProfile:utilities:water',

  OrgManagerInvestment = 'orgManager:Investment',
  OrgManagerInvestmentEquityInvestments = 'orgManager:Investment:EquityInvestments',

  Strategy = 'strategy',
  home = 'home',

  ESGPeerBechmarking = '',
  ESPGapAnalysis = 'gapAnalysis',

  PCF = 'pcf'
}
